module.exports = __webpack_public_path__ + "img/france-external-causes-male.50dfd7cd.png";